import { render, staticRenderFns } from "./FileInput.vue?vue&type=template&id=63d73528&scoped=true"
import script from "./FileInput.vue?vue&type=script&lang=js"
export * from "./FileInput.vue?vue&type=script&lang=js"
import style0 from "./FileInput.vue?vue&type=style&index=0&id=63d73528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d73528",
  null
  
)

export default component.exports